import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    FETCH_IN_INVOICES_PHASE_TASK_ITEM, FETCH_IN_INVOICES_PHASE_TASK_ITEM_ERROR,
    FETCH_IN_INVOICES_PHASE_TASK_ITEM_SUCCESS, IncomingInvoicePhaseTaskItemViewActionTypes
} from "../../actions/incoming-invoice/IncomingInvoicePhaseTaskItemActions";
import {IncomingInvoicePhaseTaskItem} from "../../models/accounting/IncomingInvoiceItem";



export type InvoiceItemFetchState<T> = {
    entries: T
    request: RequestState
}

export interface IncomingInvoicePhaseTaskItemsState {
    flatRateItems: InvoiceItemFetchState< Nullable< IncomingInvoicePhaseTaskItem[] > >

}

const initialState: IncomingInvoicePhaseTaskItemsState = {
    flatRateItems: {
        request: getInitialRequestState(),
        entries: null
    },
};

export function IncomingInvoicePhaseTaskItemsReducer(
    state: IncomingInvoicePhaseTaskItemsState = initialState,
    action: IncomingInvoicePhaseTaskItemViewActionTypes
) {

    switch (action.type) {
        case FETCH_IN_INVOICES_PHASE_TASK_ITEM:
            return {
                ...state,
                flatRateItems: {
                    entries: null,
                    request: startFetchingRequestState()
                }
            };
        case FETCH_IN_INVOICES_PHASE_TASK_ITEM_SUCCESS:
            return {
                ...state,
                flatRateItems: {
                    entries: action.payload,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_IN_INVOICES_PHASE_TASK_ITEM_ERROR:
            return {
                ...state,
                flatRateItems: {
                    entries: null,
                    request: errorFetchingRequestState( action.error )
                }

            };
        default:
            return state;
    }
}